import { submitEvent, submitEventMerge, submitMerge, submitMiniAction, submitMove, trackOnNextPageImpression } from "@otto-ec/tracking-bct";
import { Logger } from "../utils/ft6bcn_logger.ts";

const emitMiniActionEvent = (featureIds) => {
    const payload = featureIds.map((featureId) => ({
        featureId,
    }));
    submitMiniAction(payload);
    Logger.log("miniaction submitted", payload);
};

const emitSustainabilityLabelClickEvent = (payload) => {
    submitEvent(payload);
    Logger.log("sustainability label click tracking (Nexus)", payload);
};

const emitDeselectShoeSizeFilterEvent = (features) => {
    const payload = {
        name: "deselect",
        features,
    };
    submitEvent({}, payload);
    Logger.log("clear shoe size filter tracking (Nexus)", payload);
};

const emitCollapsedEvent = (payload) => {
    submitMerge({}, payload);
    Logger.log("collapsed cinema tracking (Nexus)", payload);
};

const emitOpenEventMerge = (payload, eventMergeId) => {
    submitEventMerge(eventMergeId, {}, payload);
    Logger.log("open cinema event merge tracking", payload);
};

const emitOpenedEvent = (openPayload, additionalOpenedLabels) => {
    submitEvent(additionalOpenedLabels, openPayload);
    Logger.log("open cinema tracking (Nexus)", openPayload);
};

const emitClosedEvent = (closePayload, additionalClosedLabels) => {
    submitEvent(additionalClosedLabels, closePayload);
    Logger.log("close cinema tracking (Nexus)", closePayload);
};

const emitScrollEvent = (scrollPayload, additionalTrackingLabels) => {
    submitEvent(additionalTrackingLabels, scrollPayload);
    Logger.log("scroll cinema tracking (Nexus)", scrollPayload);
};

const emitFreshViewEvent = (payload, baseLevelTrackingLabels = {}) => {
    submitMerge(baseLevelTrackingLabels, payload);
    Logger.log("cinema view page tracking (Nexus)", payload);
};

const emitClickEvent = (moveActionPayload, onNextPageImpressionPayload, additionalTrackingLabels) => {
    trackOnNextPageImpression(onNextPageImpressionPayload);
    Logger.log("cinema click tile tracking - on next page impression (Nexus)", JSON.stringify(onNextPageImpressionPayload));

    submitMove(additionalTrackingLabels, moveActionPayload);
    Logger.log(
        "cinema click tile tracking - move action (Nexus))",
        JSON.stringify(additionalTrackingLabels),
        JSON.stringify(moveActionPayload)
    );
};

const emitActionViewEvent = (payload, eventMergeId, actionName) => {
    const event = {
        name: actionName,
        features: payload,
    };
    submitEventMerge(eventMergeId, {}, event);
    Logger.log(`cinema view page tracking - ${actionName} action (Nexus)`, payload);
};

const emitHypotheticalEvent = (payload) => {
    submitMerge(payload);
    Logger.log("hypothetical event emitted", payload);
};

const emitHypotheticalEventWithMergeId = (payload, eventMergeId) => {
    submitEventMerge(eventMergeId, payload);
    Logger.log("hypothetical event emitted with merge id", payload);
};

const emitRecoAddToCartButtonLabelEvent = (labels, payload) => {
    submitEvent(labels || {}, payload);
    Logger.log("Add2CartButton visible label tracking (Nexus)", payload);
};

export {
    emitMiniActionEvent,
    emitSustainabilityLabelClickEvent,
    emitDeselectShoeSizeFilterEvent,
    emitCollapsedEvent,
    emitOpenEventMerge,
    emitOpenedEvent,
    emitClosedEvent,
    emitScrollEvent,
    emitFreshViewEvent,
    emitClickEvent,
    emitActionViewEvent,
    emitHypotheticalEvent,
    emitHypotheticalEventWithMergeId,
    emitRecoAddToCartButtonLabelEvent,
};
